<template>
  <div>
    <Header></Header>
    <div class="ceping">
      <!-- 微导航 -->
      <div class="wnav">
        <span>课程体系</span> >
        <span>更多测评</span> >
        <span>测评详情</span> >
        <span class="gengduo">{{name}}</span>
      </div>
      <div class="title">{{name}}</div>
      <div class="cont">
        <div v-for="(list,index) in lists" :key="index">
          <div class="timu">
            {{index+1}}.{{list.name}}
            <span v-show="list.type==3">多选</span>
          </div>
          <ul>
            <li v-for="(data,index) in list.data" :key="index">
              <label>
                <input
                  class="radio_type"
                  type="checkbox"
                  v-model="list.answer"
                  :value="data.abcd"
                  v-if="list.type==3"
                />
                <input
                  class="radio_type"
                  type="radio"
                  v-model="list.answer"
                  :value="data.abcd"
                  v-if="list.type==1"
                  :name="list.id"
                />
                <span>{{data.abcd}}</span>
                .{{data.name}}
              </label>
            </li>
          </ul>
          <textarea
            v-model="list.answer"
            v-show="list.type==2"
            id="memo"
            style="min-height: 106px;min-width: 522px;max-height: 106px; max-width: 522px;"
          ></textarea>
        </div>
        <div class="btn" @click="btn()">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
export default {
  name: "",
  data() {
    return {
      id: "",
      lists: [],
      name: "",
      checkList: []
    };
  },
  created() {
    var id = this.$route.query.id;
    var title = this.$route.query.name;

    this.name = title;
    this.id = id;
  },
  methods: {
    // 提交
    async btn() {
      let end = 0;
      this.lists.map((i, index) => {
        if (this.lists.length - 1 == index) {
          end = 1;
        }
        var id = JSON.parse(sessionStorage.getItem("data"));
        this.$service.home
          .user_answer({
            uid: id.id,
            id: i.id,
            answer: i.answer.toString(),
            end: end
          })
          .then(res => {
            // console.log(res);
            if (res.data.code == 200) {
              if(res.data.content){
              this.$router.push({
                path: "/evalu_success",
                 query: {
                    id: res.data.content.appraisalmy_id,
                    name:this.name
                  }
              });
              }
              
            }
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    //  测评题目列表
    async appraisal_content() {
      var id = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .appraisal_content({
          uid: id.id,
          id: this.id
        })
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.lists = res.data.content;
            this.lists.map(item => {
              if (item.type == "3") {
                item.answer = [];
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    this.appraisal_content();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.radio_type {
  width: 20px;
  height: 20px;
  appearance: none;
  position: relative;
  outline: none;
}
.radio_type:before {
  content: "";
  width: 15px;
  height: 15px;
  border: 1px solid #cccccc;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
}
.radio_type:checked:before {
  content: "";
  width: 15px;
  height: 15px;
  border: 1px solid #cccccc;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
}
.radio_type:checked:after {
  content: "";
  width: 9px;
  height: 9px;
  text-align: center;
  background: #1775ef;
  border-radius: 50%;
  display: block;
  position: absolute;
  top: 4px;
  left: 4px;
}
.ceping {
  width: 1200px;
  margin: 0 auto;
}
/* 微导航 */
.ceping .wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.ceping .wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.ceping .title {
  font-size: 28px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-bottom: 12px;
}
.ceping .cont {
  width: 1200px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  padding: 20px 0 10px 20px;
}
.ceping .cont .timu {
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  margin-bottom: 10px;
}
.ceping .cont ul {
  margin: 0;
  padding: 0;
}
.ceping .cont ul li {
  margin-bottom: 6px;
}
.ceping .cont textarea {
  background: #f1f1f1;
  border: none;
}
.ceping .cont .btn {
  width: 154px;
  height: 44px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  text-align: center;
  margin-top: 29px;
}
</style>



// WEBPACK FOOTER //
// src/components/cptx/evalu_ceping.vue